import { render, staticRenderFns } from "./StreamItem.vue?vue&type=template&id=485bca0e&"
import script from "./streamItem.js?vue&type=script&lang=js&"
export * from "./streamItem.js?vue&type=script&lang=js&"
import style0 from "./StreamItem.vue?vue&type=style&index=0&id=485bca0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports